import ShoppingHeader from './shoppingHeader';

export default ShoppingHeader;
